import React from 'react'
import { Link } from '@chakra-ui/react'
import { Link as ReactLink } from "react-router-dom";


const Home = () => {
    // const navigate = useNavigate()

    return (
        <div>
            <Link as={ReactLink} to='/admin_area/signin'>Go to Login</Link>
            <Link as={ReactLink} to='/admin_area'>GO to Secure Dashboard</Link>
            <Link as={ReactLink} to='/admin_area2'>GO to Secure Dashboard 2</Link>
        </div>
    )
}

export default Home
//test